<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-06-27 15:12:46
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-07 17:09:12
 * @FilePath: \合联\oms\src\view\costRule\deliveryCostQuoteRule\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/costRule/clearanceCostQuoteRule";
export default {
  name: "clearanceCostQuoteRule",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                continued: this.list,
              });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1000,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              clearance_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              clearance_fee: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              clearance_vat: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              bayan: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              truck_fee: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              truck_vat: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              start_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
              end_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
            },
          },
          grid: [
            {
              country: 12,
              currency: 12,
              clearance_type: 12,
              clearance_fee: 12,
              clearance_vat: 12,
              bayan: 12,
              truck_fee: 12,
              truck_vat: 12,
              start_time: 12,
              end_time: 12,
              agent_id: 24,
              remarks: 24,
            },
          ],
          fields: [
            {
              name: this.$tz("关联,代理"),
              key: "agent_id",
              component: "Select",
              placeholder: () => this.$tz("关联,代理"),
              options: [],
              optionsFn: "getTransportAgent",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("国家"),
              key: "country",
              component: "Select",
              placeholder: () => this.$tz("国家"),
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("币种"),
              key: "currency",
              component: "Select",
              placeholder: () => this.$tz("币种"),
              options: [],
              optionsFn: "getCurrency",
              optionsKey: "",
              default: "",
            },
            {
              name: () => this.$tz("开始时间"),
              key: "start_time",
              placeholder: () => this.$tz("开始时间"),
              component: "DatePicker",
              disabledDate: true,

              bind: {
                type: "date",
              },
            },
            {
              name: () => this.$tz("结束时间"),
              key: "end_time",
              placeholder: () => this.$tz("结束时间"),
              component: "DatePicker",
              disabledDate: true,

              bind: {
                type: "date",
              },
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
            },
            {
              name: this.$tz("清关费,计费方式"),
              key: "clearance_type",
              component: "Select",
              placeholder: () => this.$tz("清关费,计费方式"),
              options: [],
              optionsFn: "costChargeType",
              optionsKey: "",
              default: "",
            },
            {
              name: () => this.$tz("清关费"),
              key: "clearance_fee",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("清关费,VAT"),
              key: "clearance_vat",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("Bayan"),
              key: "bayan",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("拖车费"),
              key: "truck_fee",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("拖车费,VAT"),
              key: "truck_vat",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("请选择,日期,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "COST_DELIVERY_RULE_DATA_TYPE",
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "country",
            placeholder() {
              return this.$tz("请选择,国家");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
          {
            key: "currency",
            placeholder() {
              return this.$tz("请选择,币种");
            },
            component: "Select",
            options: [],
            optionsFn: "getCurrency",
            optionsKey: "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
              id: 1759,
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
                this.list.push({
                  lower_weight: "",
                  upper_weight: "",
                  step_weight: "",
                  price: "",
                });
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("country_t"),
          key: "country",
          minWidth: 130,
        },
        {
          name: () => this.$t("currency_t"),
          key: "currency",
          minWidth: 130,
        },
        {
          name: () => this.$tz("清关费,单价"),
          key: "clearance_fee",
          minWidth: 110,
        },
        {
          name: () => this.$tz("清关费,VAT"),
          key: "clearance_vat",
          minWidth: 110,
        },
        {
          name: () => this.$tz("清关费,计费方式"),
          key: "clearance_type_txt",
          minWidth: 110,
        },
        {
          name: () => this.$tz("Bayan"),
          key: "bayan",
          minWidth: 110,
        },
        {
          name: () => this.$tz("拖车费"),
          key: "truck_fee",
          minWidth: 110,
        },
        {
          name: () => this.$tz("拖车费,VAT"),
          key: "truck_vat",
          minWidth: 110,
        },
        {
          name: () => this.$tz("关联,代理"),
          key: "agent_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("开始时间"),
          key: "start_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("结束时间"),
          key: "end_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
              id: 1759,
            },
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              id: 1758,
            },
          ],
          methods: {
            update({ row }) {
              this.getModal("add").open(row, function () {
                this.list = row.continued;
                this.setTitle(this.$tz("编辑"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>